<template>
  <div class="store">
    <div class="banxin">
      <div class="shop">
        <img class="shopLogo" :src="shopLogo" alt="">
        <h2 class="shopName">{{shopName}}</h2>
      </div> 
       
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="店铺首页" name="index"></el-tab-pane>
        <el-tab-pane label="所有商品" name="all"></el-tab-pane>
        <el-tab-pane :label="item.classifyName" v-for="item in shopClassifyList" :key="item.classifyId" :name="item.classifyId.toString()"></el-tab-pane>
      </el-tabs>
      <div v-if="isIndex">
        <canvas-page v-if="shopId" :terminal="4" :typeId="3" :shopId="shopId"></canvas-page>
      </div>
      <div v-else>
        <img v-if="banner" class="banner" :src="banner" alt="">
        <div class="content">
          <div class='sort'>
            <div>排序：</div>
            <div class='default' :class="index=='1'?'active':''" @click="defaultSort()">默认</div>
            <div class='price' :class="index=='2'?'active':''" @click="priceSort()">
              价格
              <div class='arr'>
                <div class='up' :class="type==1?'low':''"></div>
                <div class='down' :class="type==2?'high':''"></div>
              </div>
            </div>
            <div class='sales' :class="index=='3'?'active':''" @click="salesSort()">
              销量
              <img v-show="index!=='3'" src='../../../static/image/reduce@2x.png' alt='' />
              <img v-show="index=='3' && volume==1" src='../../../static/image/reduce2@2x.png' alt='' />
              <img v-show="index=='3' && volume==2" src='../../../static/image/reduce1@2x.png' alt='' />
            </div>
          </div>
          <div>
            <div v-if="noProduct==false">
              <h3>{{classifyTitle}}</h3>
              <ProductList :productList='productList'></ProductList>
            </div>
            <div class="noproduct" v-else>
              <img src="../../../static/image/nothing@2x.png" alt="">
              <p class="fs20 font-color-999">该分类没有商品～</p>
            </div>
          </div>
          <el-pagination v-if="productList.length>0" :current-page="page" :page-size="12" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lxkf from '../../new/lxkf'
import ProductList from '../../components/base/productList'
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import {mapMutations} from 'vuex'
import CanvasPage from '../../components/canvasShow/canvasShowPage'
export default {
  mixins: [listSearchMixin],
  components: {
    ProductList,
    CanvasPage,
    lxkf
  },
  data () {
    return {
      banner: '',
      activeName: 'index',
      index: '1',
      classifyTitle: '',
      shopClassifyList: [],
      shopId: null,
      productList: [],
      shopName: null,
      shopLogo: null,
      total: 0,
      type: '',
      volume: '',
      page: 1,
      noProduct: false,
      isIndex: true
    }
  },
  mounted () {
    // var shopData = this.$route.query.shopId
    // console.log(shopData)
    this.shopId = parseInt(this.$route.query.shopId)
    this.getShopIndex()
    this.getShopClassify()
    this.getShopBanner()
  },
  methods: {
    ...mapMutations({
      setCollectData: 'SET_COLLECTDATA'
    }),
    // 获取店铺首页
    getShopIndex () {
      let params = {
        url: api.getShopIndex + `?shopId=${this.shopId}`,
        method: 'GET'
      }
      this.sendReq(params, (res) => {
        if (res.code === '200') {
          let data = {
            ifCollect: res.data.ifCollect,
            collectId: res.data.collectId,
            shopAdress: res.data.shopAdress,
            shopName: res.data.shopName,
            shopId: res.data.shopId,
            classifyNumber: res.data.classifyNumber,
            number: res.data.number,
            shopLogo: res.data.shopLogo
          }
          this.shopName = res.data.shopName
          this.shopLogo = res.data.shopLogo
          this.setCollectData(data)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 获取店铺分类
    getShopClassify () {
      let self = this
      let params = {
        url: api.getShopClassify + `?shopId=${self.shopId}`,
        method: 'GET',
        data: {
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.shopClassifyList = res.data.filter(item => JSON.stringify(item) !== '{}')
          // self.activeName = res.data[0].classifyId.toString()
          // self.classifyTitle = res.data[0].classifyName
          // self.getShopProducts()
        } else {
          self.$message({
            message: res.message,
            type: 'warning'
          })
        }
      })
    },
    // 获取店铺banner
    getShopBanner () {
      let self = this
      let params = {
        url: api.getShopBanner + `?shopId=${self.shopId}`,
        method: 'GET',
        data: {
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          if (res.data.length > 0) {
            self.banner = res.data[0].bannerImage
          }
        } else {
          self.$message({
            message: res.message,
            type: 'warning'
          })
        }
      })
    },
    // 获取店铺商品
    getShopProducts () {
      let self = this
      let _url = api.getShopProducts + `?shopId=${self.shopId}&ifNew=&type=${self.type}&volume=${self.volume}&page=${self.page}&pageSize=12`
      if (self.activeName !== 'all') {
        _url += `&classifyId=${self.activeName}`
      }
      let params = {
        url: _url,
        method: 'GET',
        data: {
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.productList = res.data.page.list
          self.shopName = res.data.shopName
          self.total = res.data.page.total
          self.shopLogo = res.data.shopLogo
          if (res.data.page.list.length < 1) {
            self.noProduct = true
          }
        } else {
          self.$message({
            message: res.message,
            type: 'warning'
          })
        }
      })
    },
    // 分类切换
    handleClick (event) {
      this.classifyTitle = event.label
      if (event.name === 'index') {
        this.isIndex = true
      } else {
        this.isIndex = false
        this.getShopProducts()
      }
    },
    // 分页器跳转
    handleCurrentChange (val) {
      this.page = val
      this.getShopProducts()
    },
    // 默认排序
    defaultSort () {
      this.type = ''
      this.volume = ''
      this.index = '1'
      this.page = 1
      this.getShopProducts()
    },
    // 价格排序
    priceSort () {
      if (this.type !== 1) {
        this.type = 1
      } else {
        this.type = 2
      }
      this.page = 1
      this.volume = ''
      this.index = '2'
      this.getShopProducts()
    },
    // 销量排序
    salesSort () {
      if (this.volume !== 1) {
        this.volume = 1
      } else {
        this.volume = 2
      }
      this.page = 1
      this.type = ''
      this.index = '3'
      this.getShopProducts()
    }
  }
}
</script>
<style lang = "scss" scoped>
.store {
  width: 100%;
  margin-top: 30px;
  //text-align: center;
  padding-bottom: 143px;
  .banxin {
    width: 1252px;
    margin: 0 auto;
    .shop{
      margin-bottom: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      .shopLogo{
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      .shopName{
        font-size: 30px;
        font-weight: bold;
      }
    }
    >>>.el-tabs{
      margin-bottom: 10px;
      .el-tabs__item.is-active{
        color: #FF7800;
      }
      .el-tabs__active-bar{
        background-color: #FF7800;
      }
      .el-tabs__item{
        font-size: 16px;
      }
      .el-tabs__item:hover{
        color: #FF7800;
      }
      .el-tabs__nav-wrap::after{
        display: none;
      }
    }
    .banner{
      width: 100%;
      height: 356px;
      margin-bottom: 25px;
    }
    .content{
      width: 100%;
      padding: 0 45px 30px;
      box-sizing: border-box;
      .sort {
        width: 100%;
        height: 63px;
        line-height: 27px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;
        color: #666666;
        margin-bottom: 50px;
        .default {
          margin-left: 20px;
          cursor: pointer;
        }
        .sales {
          cursor: pointer;
          img{
            width: 9px;
            height: 16px;
            vertical-align: middle;
          }
        }
        .price {
          display: flex;
          margin: 0 20px;
          cursor: pointer;
          .arr {
            vertical-align: middle;
            width: 12px;
            margin-left: 3px;
            .up {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-bottom-color: #999999;
            }
            .down {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-top-color: #999999;
              margin-top: 3px;
            }
          }
        }
        .active{
          color: #FF7800;
          .arr{
            .high{
              border-top-color: #FF7800;
            }
            .low{
              border-bottom-color: #FF7800;
            }
          }
        }
      }
      h3{
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 80px;
      }
      .noproduct{
        width: 100%;
        text-align: center;
        padding: 200px 0;
      }
    }
    >>>.el-pagination{
      text-align: right;
      .el-pager{
        li:not(.disabled):hover{
          color: #FF7800;
        }
        li:not(.disabled).active{
          background-color: #FF7800;
        }
        li:not(.disabled).active:hover{
          color: #F4F4F5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/store/index.vue